<template>
  <div class="chat container col s12 m12 l10" >
    <h5 class="text-white">Online:{{name}}</h5> <ul >
      <li><a  @click="sortieren('n')">Name</a></li>
      <li><a  @click="sortieren('a')">Alter</a></li>
      <li><a  @click="sortieren('r')">Region</a></li></ul>
    <div class="row">
      <div v-if="alluser" v-for="(message, index) in uniqueNames" :key="index" class="col s2">
        <div class="card userbackground z-depth-5" >
          <div class="card-image" >
            <img v-bind:src="message.img" height="100px">
            <span class="card-title">{{message.name}}</span>
          </div>
          <div class="card-content white-text">
           <p>I am a very simple card.
            </p>
            <p>Age: {{message.alter}}</p>
            <p>Region: {{message.region}}</p>
            </div>
          <div class="card-action">
            <a  @click="enterPrivatChat(message.name)">Chat</a>
            <a  @click="anzeigen({index})">Anzeigen</a>
            <a  @click="enterMessage(message.name)">Message</a>
          </div>
          </div>
        </div>
    <div v-if="!alluser" class="col s6 ">
      <div class="card userbackground z-depth-5" >
        <div class="card-image" style="margin-left: 30px;padding-top: 20px">
          <img v-bind:src="onlineusers[this.index].img" style="height: 200px; width: 300px">
         <span class="card-title">{{onlineusers[this.index].name}}</span>
        </div>
        <div class="card-content white-text" >
          <p>I am a very simple card.
            bits of information.I am a very simple card.
            bits of information.I am a very simple card.
            bits of information.
             </p>
        </div>
        <div class="card-action" >
        <p class="white-text">Age: {{onlineusers[this.index].alter}}</p>
        </div>
        <div class="card-action" >
          <p class="white-text"> Region: {{onlineusers[this.index].region}}</p>
        </div>
        <div class="card-action">
          <a @click="zuruck">Zurück</a>
        </div>
      </div>
      <template v-if="!alluser">  <GMap   v-bind:onlineusers="[{zoom:13, colname:'friends', user:onlineusers[this.index].name, lat:[onlineusers[this.index].geolocation.lat,onlineusers[this.index].geolocation.lng]}]"></GMap></template>
    </div>
      <template v-if="alluser">  <GMap   v-bind:onlineusers="[{zoom:9,colname:'friends',user:'',lat:[47.05055,8.30547]}]"></GMap></template>
      <div class="row">
        <carousel :data="data" :controls="true"></carousel>
      </div>
    </div>

  </div>
</template>

<script>
    import {moduladdArrayElement, modulPushroute,setDestinationUser} from "../firebase/GlobalDBFunctions"
    import {modulloadOnlineUser,modulloadOnlineImgs} from "../firebase/OnlineDBFunction"
    import {modulgetRefDB, modulgetRefDBWhere} from "../firebase/MainDBManager";
    import {modulSort} from "../firebase/GlobalFunctions";
    import Vue from 'vue';
    import VueCarousel from '@chenfengyuan/vue-carousel';
    import GMap from "./GMap/GMap";
    Vue.component(VueCarousel.name, VueCarousel);

    export default {
        name: "Online",
        components: {GMap},
        props:["name"],
        data() {
            let refDB;
            let ref;
            return {
                contentslider:[],
                onlineusers: [],
                count:0,
                alluser:true,
                index:0,
                holder:name,
                data:[],
                refDB,
                ref,
                col:'friends'
                }
        },
        methods: {
             enterPrivatChat(neuePerson) {
                 this.ref =modulgetRefDBWhere("friends", 'name', this.$route.params.name);
                 moduladdArrayElement(this.ref, this.$route.params.name, neuePerson, this.$router, 'PrivatChat');
            },
            enterMessage(neuePerson) {
                setDestinationUser(neuePerson);
                modulPushroute(this.$route.params.name, neuePerson, this.$router, 'UserMessage');
            },
            anzeigen: function(index){
                  this.alluser=false;
                  this.index = index.index
            },

            sortieren: function(type){
                 modulSort(this.onlineusers, type);
            },
            anzeigenChat: function(index){
                this.alluser=false;
                this.index = index.index
            },
            zuruck: function(){
                this.alluser=true;
            },
            loadOnlineUser: function(){
                this.ref=modulgetRefDB('friends','name');
                modulloadOnlineUser(this.ref,this.onlineusers,this.$route.params);
            },
            loadOnlineImgs: function(){
                 modulloadOnlineImgs(this.ref,this.data,this.$route.params)
            },
        },
    computed: {
        uniqueNames: function() {
            let onlineusersnew = [];
            for (let i = 0; i < this.onlineusers.length; i++) {
                if (onlineusersnew.indexOf(this.onlineusers[i].name) === -1) {
                    onlineusersnew.push(this.onlineusers[i])
                }
            }
            return onlineusersnew;
        }
    },
        created() {
            this.loadOnlineUser();
            this.loadOnlineImgs();
        }
    }
</script>

<style scoped>
  .chat h2{
    font-size: 2.6em;
    margin-bottom: 40px;
  }
  .chat span{
    font-size: 1.4em;
  }
  .chat .time{
    font-size: 0.8em;
  }
  .chat .name{
    text-align: right;
    width: 40px;
    font-size: 0.9em;
  }

  .messages {
    max-height: 300px;
    overflow: auto;
  }
  .user{
    margin-top: -15px;
    margin-left: -10px;
    margin-right: -10px;
    width: auto;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: #0033cc;
  }

  li {
    float: left;
  }

  li a {
    display: block;
    color: white;
    text-align: center;
    padding: 8px;
    text-decoration: none;
  }

  li a:hover {
    background-color: #111111;
  }

  .userbackground{
    background: rgba(0, 0, 0, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/Online.vue